import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

import { getEnv } from './utils/env';

const env = getEnv();

if (env !== 'localhost') {
    Sentry.init({
        dsn: 'https://89df71ef0916c63b24bb77b399c4474f@o4507339024957440.ingest.de.sentry.io/4507345555161168',
        integrations: [
            // See docs for support of different versions of variation of react router
            // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
            Sentry.replayIntegration(),
        ],
        environment: env,

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        tracesSampleRate: 1.0,

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', 'https://api.vake.ai'],

        // Capture Replay for 0% of all sessions,
        replaysSessionSampleRate: 0,
        // Capture Replay for 0% of sessions with an error
        replaysOnErrorSampleRate: 0,
    });
}
